import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(24);
  return {
    icon: {
      width: size,
      height: size,
      fill: 'orange',
    },
  };
});

const RouteStatusIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon}>
      <path d="M12.191 1.44C18.023 1.44 22.751 6.168 22.751 12C22.751 17.832 18.023 22.56 12.191 22.56C6.35901 22.56 1.63101 17.832 1.63101 12C1.63101 6.168 6.35901 1.44 12.191 1.44ZM12.191 0C5.56701 0 0.19101 5.376 0.19101 12C0.19101 18.624 5.56701 24 12.191 24C18.815 24 24.191 18.624 24.191 12C24.191 5.376 18.815 0 12.191 0Z" />
      <path d="M15.551 4.8C15.131 4.8 14.759 5.076 14.639 5.472C14.627 5.496 14.615 5.532 14.615 5.568L11.987 14.928L9.23901 8.748C9.22701 8.724 9.21501 8.688 9.20301 8.664C9.03501 8.352 8.71101 8.16 8.36301 8.16C8.05101 8.16 7.75101 8.316 7.57101 8.568C7.57101 8.58 7.57101 8.592 7.57101 8.592L5.91501 11.04H3.55101C3.02301 11.04 2.59101 11.472 2.59101 12C2.59101 12.528 3.02301 12.96 3.55101 12.96H6.43101C6.74301 12.96 7.04301 12.804 7.22301 12.552V12.516L8.18301 11.1L11.303 18.132C11.315 18.156 11.327 18.192 11.339 18.216C11.591 18.684 12.179 18.852 12.635 18.6C12.851 18.48 13.019 18.276 13.091 18.036L15.683 8.796L17.027 12.276C17.039 12.312 17.051 12.336 17.063 12.372C17.219 12.732 17.555 12.96 17.951 12.96H20.831C21.359 12.96 21.791 12.528 21.791 12C21.791 11.472 21.359 11.04 20.831 11.04H18.611L16.475 5.472C16.463 5.436 16.451 5.412 16.439 5.376C16.283 5.028 15.935 4.8 15.551 4.8Z" />
    </SvgIcon>
  );
};

export default memo(RouteStatusIcon);
